// extracted by mini-css-extract-plugin
export default {"container":"container__2So12","dragAccepted":"dragAccepted__z+zyI","icon":"icon__sgNtD","instruction":"instruction__ZGkuJ"};